import React, { useContext, useEffect, useState } from 'react';
import { Tooltip } from 'antd';
import { Link } from 'react-router-dom';
import { SingleProductPageContextStart } from '../Context/SingleProductPageContext';
import { SingleCategoryPageContextStart } from '../Context/SingleCategoryPageContext';
import { CartContextStart } from '../Context/CartContext';
import ProductsData from '../components/ProductsData';
import SingleProduct from '../components/SingleProduct';
import Footer from '../components/Footer';


export default function SingleProductPage() {

    const [getProductData, setGetProductData] = useState(JSON.parse(localStorage.getItem("product")) || {});
    const [getSearchResult, setGetSearchResult] = useState(JSON.parse(localStorage.getItem("searchResult")) || []);
    const [desiredIndex, setDesiredIndex] = useState();

    const { productDetail, setProductDetail } = useContext(SingleProductPageContextStart);
    const { setCategoryDetail } = useContext(SingleCategoryPageContextStart);
    const { cartItems, setCartItems } = useContext(CartContextStart);

    // Product/CartItem Quantity Counter
    const [itemQuantity, setItemQuantity] = useState(1);

    const settingCategoryPageContextValue = (categoryName) => {
        setCategoryDetail(categoryName);
        localStorage.setItem("category", categoryName);
    }


    let filteredProducts = [];

    for (let i = 0; i < ProductsData.length; i++) {
        if ((ProductsData[i].pCategory === getProductData.pCategory) && (ProductsData[i].pTitle !== getProductData.pTitle)) {
            if (filteredProducts.length < 4) {
                filteredProducts.push(ProductsData[i]);
            }
        }
    }

    useEffect(() => {
        window.scrollTo(0, 0);
        setGetProductData(JSON.parse(localStorage.getItem("product")));
    }, [productDetail]);

    /* Checking that which product is
    right now open (in single product page)
    and getting its index */

    useEffect(() => {
        for (let i = 0; i < getSearchResult.length; i++) {
            if (getSearchResult[i].pid === getProductData.pid) {
                setDesiredIndex(i);
            }
        }
    }, [getProductData]);

    // Navigating to Previous and Next Product
    const goToPreviousProduct = () => {
        if (desiredIndex > 0) {
            localStorage.setItem("product", JSON.stringify(getSearchResult[desiredIndex - 1]));
            setProductDetail(getSearchResult[desiredIndex - 1]);
        }
    }

    const goToNextProduct = () => {
        if (desiredIndex < (getSearchResult.length - 1)) {
            localStorage.setItem("product", JSON.stringify(getSearchResult[desiredIndex + 1]));
            setProductDetail(getSearchResult[desiredIndex + 1]);
        }
    }

    return (
        <>
            <div className="container-fluid home-container mb-4">
                <div className="row singleProductDetails gap-4">
                    <div className="col-lg image-side">
                        <img src={getProductData.pLargeImg} alt="Product" />
                    </div>
                    <div className="col-lg details-side pt-3">
                        <div className="single-product-details-header mb-3 d-flex justify-content-between align-items-center">
                            <p className='breadcrumb m-0'>
                                <Link to="/">Home</Link>&nbsp;/&nbsp;
                                <Link onClick={() => { settingCategoryPageContextValue(getProductData.pCategory) }} to={`/category`}>{getProductData.pCategory}</Link> &nbsp;/&nbsp;
                                <a>{getProductData.pTitle}</a>
                            </p>
                            <div className="forward-backward d-flex gap-2">
                                <Tooltip placement="bottom" color="#3a3a3a" title="Previous Product">
                                    <button onClick={goToPreviousProduct}>
                                        <svg className="ast-arrow-svg arrow-left" xmlns="http://www.w3.org/2000/svg" viewBox="57 35.171 26 16.043">
                                            <path d="M57.5,38.193l12.5,12.5l12.5-12.5l-2.5-2.5l-10,10l-10-10L57.5,38.193z"></path>
                                        </svg>
                                    </button>
                                </Tooltip>
                                <Tooltip placement="bottom" color="#3a3a3a" title="Next Product">
                                    <button onClick={goToNextProduct}>
                                        <svg className="ast-arrow-svg arrow-right" xmlns="http://www.w3.org/2000/svg" viewBox="57 35.171 26 16.043">
                                            <path d="M57.5,38.193l12.5,12.5l12.5-12.5l-2.5-2.5l-10,10l-10-10L57.5,38.193z"></path>
                                        </svg>
                                    </button>
                                </Tooltip>
                            </div>
                        </div>
                        <div className="single-product-details-body">
                            <h1>{getProductData.pTitle}</h1>
                            <p className='single-product-price mb-2'>
                                <span>£{getProductData.pPrice} </span>
                                <span>+ Free Shipping</span>
                            </p>
                            <p className='single-product-short-desc'>
                                {getProductData.pShortDesc}
                            </p>
                            <div className="add-to-cart d-flex gap-3 align-items-center">
                                <div className="cart-item-counter">
                                    <button onClick={() => { setItemQuantity(itemQuantity > 1 ? itemQuantity - 1 : itemQuantity) }}>-</button>
                                    <button className="cart-item-counter-value">{itemQuantity}</button>
                                    <button onClick={() => { setItemQuantity(itemQuantity + 1) }}>+</button>
                                </div>

                                {
                                    cartItems.some((singleItem) => singleItem.getProductData.pid === getProductData.pid)
                                        ?
                                        (
                                            <button
                                                className='add-to-cart-btn'
                                                onClick={() => {
                                                    setCartItems(cartItems.filter((singleItem) => {
                                                        return singleItem.getProductData.pid !== getProductData.pid;
                                                    }))
                                                }}
                                            >Remove From Cart</button>
                                        )
                                        :
                                        (
                                            <button
                                                className='add-to-cart-btn'
                                                onClick={() => { setCartItems([...cartItems, { getProductData, itemQuantity }]) }}
                                            >Add To Cart</button>
                                        )
                                }

                            </div>
                        </div>
                        <div className="single-product-details-footer">
                            <p>
                                <span>Categories: </span>
                                <Link onClick={() => { settingCategoryPageContextValue(getProductData.pCategory) }} to={`/category`}>{getProductData.pCategory}</Link>
                            </p>
                            <fieldset className="payment-methods">
                                <legend>Guaranteed Safe Checkout</legend>
                                <div className="payment-method-icons d-flex justify-content-center gap-2 align-items-center">
                                    <i className="fa-brands fa-cc-visa"></i>
                                    <i className="fa-brands fa-cc-mastercard"></i>
                                    <i className="fa-brands fa-cc-amex"></i>
                                    <i className="fa-brands fa-cc-discover"></i>
                                </div>
                            </fieldset>
                        </div>
                    </div>
                </div>
                <div className="row mt-5 product-long-description">
                    <h1>Description</h1>
                    <p>
                        {getProductData.pLongDesc}
                    </p>
                </div>

                <div className="row mt-5 product-long-description">
                    <h1>Related Products</h1>
                    <div className="row pt-3">
                        {filteredProducts.map((singleProduct) => {
                            return (
                                <SingleProduct
                                    key={singleProduct.pid}
                                    productImg={singleProduct.pImg}
                                    productCategory={singleProduct.pCategory}
                                    productTitle={singleProduct.pTitle}
                                    productPrice={singleProduct.pPrice}
                                    product={singleProduct}
                                    mb="5"
                                />
                            );
                        })}
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}
